import React from 'react';
import Testimonial from '../../components/Testimonial/Testimonial';
import TeamImg1 from '../../assets/images/testimonial/testimonial-1-1.jpg';
import TeamImg2 from '../../assets/images/testimonial/testimonial-1-2.jpg';
import TeamImg3 from '../../assets/images/testimonial/testimonial-1-3.jpg';
import TeamImg4 from '../../assets/images/testimonial/testimonial-1-4.jpg';
import TeamImg5 from '../../assets/images/testimonial/testimonial-1-5.jpg';
import TeamImg6 from '../../assets/images/testimonial/testimonial-1-6.jpg';

const TestimonialsMain = () => {
    // Example testimonials member data
    const testimonials = [
        {
          imgSrc: TeamImg1,
          name: 'Cameron Williamson',
          title: 'Pro Roofing Experts',
          text: 'Construction is an essential industry that invo building and designing structures such as buildings, roads, bridges and more. It requires skilled workers, materials and the careful planning to ensure successful.',
          rating: 5,
          link: '/testimonials',
        },
        {
          imgSrc: TeamImg2,
          name: 'Sajid Hasan',
          title: 'Roofing Masters',
          text: 'Construction is an essential industry that invo building and designing structures such as buildings, roads, bridges and more. It requires skilled workers, materials and the careful planning to ensure successful.',
          rating: 5,
          link: '/testimonials',
        },
        {
          imgSrc: TeamImg3,
          name: 'Adam Smith',
          title: 'Roof Renovation',
          text: 'Construction is an essential industry that invo building and designing structures such as buildings, roads, bridges and more. It requires skilled workers, materials and the careful planning to ensure successful.',
          rating: 5,
          link: '/testimonials',
        },
        {
          imgSrc: TeamImg4,
          name: 'Robert Son',
          title: 'Roof Renovation',
          text: 'Construction is an essential industry that invo building and designing structures such as buildings, roads, bridges and more. It requires skilled workers, materials and the careful planning to ensure successful.',
          rating: 5,
          link: '/testimonials',
        },
        {
          imgSrc: TeamImg5,
          name: 'Adam Milne',
          title: 'Roof Renovation',
          text: 'Construction is an essential industry that invo building and designing structures such as buildings, roads, bridges and more. It requires skilled workers, materials and the careful planning to ensure successful.',
          rating: 5,
          link: '/testimonials',
        },
        {
          imgSrc: TeamImg6,
          name: 'Robert Illingworth',
          title: 'Roof Renovation',
          text: 'Construction is an essential industry that invo building and designing structures such as buildings, roads, bridges and more. It requires skilled workers, materials and the careful planning to ensure successful.',
          rating: 5,
          link: '/testimonials',
        },
        // Add more testimonials as needed...
      ];

    return (
        <React.Fragment>
        {/*Testimonial Page Start*/}
          <section className="testimonial-page">
            <div className="container">
              <div className="row">
                {testimonials.map((testimonial, index) => (
                  <Testimonial key={index} testimonial={testimonial} />
                ))}
              </div>
            </div>
          </section>
        {/*Testimonial Page End*/}
        </React.Fragment>
    );
};

export default TestimonialsMain;
